import { TAGS } from "../constants";
import { Question, QuestionInsert } from "../types";
import { api } from "./api";

export const questionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getQuestions: builder.query<
      { data: Question[]; count: number },
      { from: number; to: number; title?: string }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/questions`,
        params,
      }),
      providesTags: [TAGS.QUESTIONS],
    }),
    createQuestion: builder.mutation<Question, QuestionInsert>({
      query: (body) => ({
        method: "POST",
        url: `/api/questions`,
        body,
      }),
      invalidatesTags: [TAGS.QUESTIONS],
    }),
  }),
});

export const { useGetQuestionsQuery, useCreateQuestionMutation } = questionsApi;
